export const WORKFLOW_CHECKS = {
  design: [['colors', 'Montar colorido'], ['samples', 'Preparación muestra corte']],
  pattern: [['sample_pattern', 'Patrón para muestra'], ['cut_pattern', 'Patrón para corte']],
  production: [['sewing_sample', 'Muestra a confección'], ['shrinkage', 'Encogimiento'], ['sheet_photo', 'Foto en ficha']],
};
export const WORKFLOW_LABELS = { design: 'Diseño', pattern: 'Patronaje', production: 'Producción' };
export function productCostSheet(product) {
  return Array.isArray(product.cost_sheet) ? product.cost_sheet[0] : product.cost_sheet;
}
export function pendingStages(sheet) {
  if (sheet?.validation_status === 'validated') return [];
  return Object.keys(WORKFLOW_LABELS).filter(stage => sheet?.[`${stage}_status`] !== 'done');
}
export function pendingChecks(sheet, stage, automaticIssues = []) {
  if (!pendingStages(sheet).includes(stage)) return [];
  return [
    ...(WORKFLOW_CHECKS[stage] || []).filter(([key]) => sheet?.workflow_checks?.[stage]?.[key]?.checked !== true).map(([, label]) => label),
    ...automaticIssues.filter(issue => issue.passed !== true).map(issue => issue.label),
  ];
}
